<template>
    <div class="mask-bg">
         <div class="login-box">
          <div class="title">抽奖记录<span @click="close"><a-icon type="close" style="font-size: medium;" /></span></div>
          <div>
                 <div class="form-box">
                   <div class="inside-table">
                      <div class="th">
                        <div>时间</div>
                        <div>金额</div>
                      </div>
                      <div class="tr" v-for="(item, key) in logList" :key="key">
                        <div>{{ timeFun(item.create_time) }}</div>
                        <div>{{ item.money }}</div>
                      </div>
                   </div>
                   <a-pagination v-model="page" :total="total_list" show-less-items hideOnSinglePage @change="handleChange"/>
                 </div>
          </div>
         </div>
    </div>
</template>

<script>
import moment from 'moment';
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      logList: [],
      page: 1,
      total_list: 1
    };
  },
  computed: {
    boxHeightRem() {
      return this.innerHeightRem;
    },
  },
  components: {
  },
  mounted() {
    this.initFun()
    // eslint-disable-next-line no-console
    console.log(moment().format('YYYY/MM/DD'));
    
  },
  methods: {
    close() {
      this.$emit('close', 'showLogModal')
    },
    async handleChange(page) {
      this.page = page
      await this.initFun()
    },
    async initFun() {
      let _info = sessionStorage.getItem('info')
      if (_info) {
        let temp = JSON.parse(_info)
        this.$store.dispatch('SET_LOADING', true)
        await this.$axios.post('/XYLPUserLog/getList', { username: temp.username, page_size: 10, page: this.page }).then((r) => {
          if (r.status === 200) {
            const { status, msg } = r.data
            if (status) {
              const { list, total_list } = r.data.data
              this.logList = list
              this.total_list = total_list
            } else this.$message.error(msg)
          }
        })
        this.$store.dispatch('SET_LOADING', false)
      }
    },
    timeFun(create_time){
      if(create_time) return  moment.unix(create_time).format('YYYY年MM月DD日 HH:mm:ss')
    }
  },

  watch: {
  }
};
</script>

<style scoped>
.mask-bg {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.60);
}

.login-box {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 311px;
  padding-bottom: 20px;
  margin: 0 auto;
  border-radius: 8px;
  background: #DF363A url('./../assets/img/bigWheel/bg_tc_zp.png') no-repeat center top / 100% auto;
}


.title {
  position: relative;
  padding: 20px 0 24px;
  color: #FFF;
  font-family: "PingFang SC";
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-align: center;
}

.title span {
  position: absolute;
  right: 10px;
}

.form-box {
  width: 287px;
  margin: 0 auto;
  padding: 12px;
  border-radius: 8px;
  background: linear-gradient(116deg, #FEFCFB 0.94%, #FFF1E3 97.09%);
  text-align: center;
}

.inside-table {
  margin-bottom: 10px;
}

.tr,
.th {
  display: flex;
  justify-content: space-between;
  align-content: center;
  text-align: center;
  color: #666;
  text-align: center;
  font-family: "SF Compact";
  font-size: 12px;
  font-style: normal;
  font-weight: 457;
  text-transform: capitalize;
}

.tr>div,
.th>div {
  height: 36px;
  line-height: 36px;
}

.tr>div:first-child,
.th>div:first-child {
  width: 60%;
}

.th>div {
  border-top: 1px solid #FFC1C2;
}

.tr>div:first-child,
.th>div:first-child {
  border-left: 1px solid #FFC1C2;
  border-right: 1px solid #FFC1C2;
  border-bottom: 1px solid #FFC1C2;
}

.tr>div:last-child,
.th>div:last-child {
  width: 40%;
  border-bottom: 1px solid #FFC1C2;
  border-right: 1px solid #FFC1C2;
}
</style>